import type { CSSFn } from '@atlaskit/menu';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { LegacyEmotionCssObject } from '../../../../../types.tsx';
import { cssFn as baseHoverIconAfter } from './base-hover-icon-after.tsx';

export const cssFn: CSSFn = (): LegacyEmotionCssObject => ({
	...baseHoverIconAfter(),
	height: `${gridSize * 5.5}px`,
});
